import { Routes, Route, Navigate } from "react-router-dom";
import AuthWrapper     from "@layout/AuthWrapper";
import RoleGuard       from "@layout/RoleGuard";
import DashboardLayout from "@layout/DashboardLayout";

// Public pages
import HomePage        from "@pages/HomePage";
import AboutPage       from "@pages/AboutPage";
import ContactPage     from "@pages/ContactPage";
import PrivacyPage     from "@pages/PrivacyPage";

// Auth pages
import LoginPage           from "@pages/LoginPage";
import ForgotPasswordPage  from "@pages/ForgotPasswordPage";
import ResetPasswordPage   from "@pages/ResetPasswordPage";
import VerifyEmailPage     from "@pages/VerifyEmailPage";
import SignUpPage          from "@pages/SignUpPage";

// Dashboard & core
import DashboardPage       from "@pages/DashboardPage";
import AvailabilityUpdatesPage from "@pages/AvailabilityUpdatesPage";
import AccountSettingsPage from "@pages/AccountSettingsPage";
import SearchPage          from "@pages/SearchPage";

// Resources
import ResourcesPage           from "@pages/ResourcesPage";
import CandidateProfilePage    from "@pages/CandidateProfilePage";
import EditProfilePage         from "@pages/EditProfilePage";

// Jobs
import JobsPage            from "@pages/JobsPage";
import MyPostedJobsPage    from "@pages/MyPostedJobsPage";
import JobDetailPage       from "@pages/JobDetailPage";

// Access control
import AccessControlPage   from "@pages/AccessControlPage";

// Resource managers
import ResourceManagersPage    from "@pages/ResourceManagersPage";
import AddResourceManagerPage  from "@pages/AddResourceManagerPage";

// Firm
import EditFirmPage        from "@pages/EditFirmPage";
import EditFirmOwnerPage   from "@pages/EditFirmOwnerPage";

// AI
import ConnectIQPage       from "@pages/ConnectIQPage";
import CreateJobPage       from "@pages/CreateJobPage";
import EditJobPage         from "@pages/EditJobPage";

const PrivatePage = ({ children }) => (
  <AuthWrapper>
    <DashboardLayout><RoleGuard>{children}</RoleGuard></DashboardLayout>
  </AuthWrapper>
);

export default function AppRoutes() {
  return (
    <Routes>
      {/* ── Public ── */}
      <Route path="/"               element={<HomePage />} />
      <Route path="/about"          element={<AboutPage />} />
      <Route path="/contact"        element={<ContactPage />} />
      <Route path="/privacy"        element={<PrivacyPage />} />

      {/* ── Auth ── */}
      <Route path="/login"                       element={<LoginPage />} />
      <Route path="/sign-in"                     element={<Navigate to="/login" replace />} />
      <Route path="/forgot-password"             element={<ForgotPasswordPage />} />
      <Route path="/reset-password/:resetLink"   element={<ResetPasswordPage />} />
      <Route path="/verify-email/:link"           element={<VerifyEmailPage />} />
      <Route path="/user/verifyaccount/:link"      element={<VerifyEmailPage />} />
      <Route path="/sign-up"                     element={<SignUpPage />} />
      <Route path="/sign-up-v2-access"           element={<SignUpPage />} />

      {/* ── Private ── */}
      <Route path="/dashboard"  element={<PrivatePage><DashboardPage /></PrivatePage>} />
      <Route path="/availability-updates" element={<PrivatePage><AvailabilityUpdatesPage /></PrivatePage>} />
      <Route path="/account-settings" element={<PrivatePage><AccountSettingsPage /></PrivatePage>} />
      <Route path="/search"     element={<PrivatePage><SearchPage /></PrivatePage>} />
      <Route path="/search-v2"  element={<PrivatePage><SearchPage /></PrivatePage>} />
      <Route path="/connectiq"  element={<PrivatePage><ConnectIQPage /></PrivatePage>} />

      {/* Resources */}
      <Route path="/resources"                              element={<PrivatePage><ResourcesPage /></PrivatePage>} />
      <Route path="/my-team"                                element={<PrivatePage><ResourcesPage /></PrivatePage>} />
      <Route path="/resources/details/:id"                  element={<PrivatePage><CandidateProfilePage /></PrivatePage>} />
      <Route path="/my-team/details/:id"                    element={<PrivatePage><CandidateProfilePage /></PrivatePage>} />
      <Route path="/my-resource-profile/details/:id"        element={<PrivatePage><CandidateProfilePage /></PrivatePage>} />
      <Route path="/profile/:id"                            element={<PrivatePage><CandidateProfilePage /></PrivatePage>} />
      <Route path="/edit-profile"                           element={<PrivatePage><EditProfilePage /></PrivatePage>} />
      <Route path="/resources/edit-resource/:id"            element={<PrivatePage><EditProfilePage /></PrivatePage>} />
      <Route path="/my-team/edit-resource/:id"              element={<PrivatePage><EditProfilePage /></PrivatePage>} />

      {/* Jobs */}
      <Route path="/jobs"           element={<PrivatePage><JobsPage /></PrivatePage>} />
      <Route path="/job/latest-jobs" element={<PrivatePage><JobsPage /></PrivatePage>} />
      <Route path="/jobs/my-posted-jobs" element={<PrivatePage><MyPostedJobsPage /></PrivatePage>} />
      <Route path="/job/my-jobs"     element={<PrivatePage><MyPostedJobsPage /></PrivatePage>} />
      <Route path="/jobs/:id"        element={<PrivatePage><JobDetailPage /></PrivatePage>} />
      <Route path="/job/details/:id" element={<PrivatePage><JobDetailPage /></PrivatePage>} />

      {/* Access control */}
      <Route path="/access-control" element={<PrivatePage><AccessControlPage /></PrivatePage>} />

      {/* Resource managers */}
      <Route path="/resource-managers"      element={<PrivatePage><ResourceManagersPage /></PrivatePage>} />
      <Route path="/add-resource-manager"   element={<PrivatePage><AddResourceManagerPage /></PrivatePage>} />

      {/* Firm */}
      <Route path="/edit-firm"              element={<PrivatePage><EditFirmPage /></PrivatePage>} />
      <Route path="/edit-firm-owner-profile" element={<PrivatePage><EditFirmOwnerPage /></PrivatePage>} />

      {/* Create / Edit Jobs */}
      <Route path="/create-job"              element={<PrivatePage><CreateJobPage /></PrivatePage>} />
      <Route path="/create-job-manually"     element={<PrivatePage><CreateJobPage /></PrivatePage>} />
      <Route path="/job/edit/:id"            element={<PrivatePage><EditJobPage /></PrivatePage>} />

      {/* Fallback */}
      <Route path="*" element={<Navigate to="/dashboard" replace />} />
    </Routes>
  );
}
